import { createUseScreenSize } from '@widergy/energy-hooks';

export const useScreenSize = createUseScreenSize({
  mobileBP: 767,
  tabletBP: 1024
});
